<template>
  <v-navigation-drawer v-model="drawer" fixed temporary right width="400px">
    <v-card flat style="max-width: 500px">
      <v-card-title>
        <Icon size="28px" class="mr-2" name="stats" /> <h3 class="grey--text">Estatísticas:</h3>
        <v-spacer />
        <v-btn @click="toggleSidebars" small icon>
          <Icon size="24px" name="paint" />
        </v-btn>
      </v-card-title>
      <portal-target name="stats">
      </portal-target>
    </v-card>
  </v-navigation-drawer>
</template>

<script>
export default {
  data() {
    return {
      drawer: false,
    }
  },
  methods: {
    toggleSidebars() {
      this.drawer = false
      this.$root.$emit('costumizerDrawer', true)
    }
  },
  mounted() {
    this.$root.$on('statsdrawer', (value) => {
      this.drawer = value
    })
  },
}
</script>

